module.exports = __webpack_public_path__ + "img/fish4.c11f0d80.png";